import { HiOutlineFlag } from 'react-icons/hi2';

import { MonospaceText } from '@/components/monospace-text';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components-new/tooltip/tooltip';

type NdcCellProps = {
  ndc: string;
  needsAttention: boolean;
  missingFields?: string[];
};

const NdcLabel = ({ ndc, needsAttention }: NdcCellProps) => {
  return (
    <div className="flex items-center gap-2">
      {needsAttention && <HiOutlineFlag className="text-amber-500" />}
      <MonospaceText>{ndc}</MonospaceText>
    </div>
  );
};

export const NdcCell = ({ ndc, needsAttention, missingFields = [] }: NdcCellProps) => {
  if (needsAttention) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span>
            <NdcLabel ndc={ndc} needsAttention={needsAttention} />
          </span>
        </TooltipTrigger>
        <TooltipContent>
          {missingFields.length > 0 ? (
            <div>
              <p className="font-medium">Missing required fields:</p>
              <ul className="mt-1 list-disc pl-4">
                {missingFields.map((field) => <li key={field}>{field}</li>)}
              </ul>
            </div>
          ) : (
            'A calculation error occurred for this NDC. Please try recalculating, or contact an administrator if the issue persists.'
          )}
        </TooltipContent>
      </Tooltip>
    );
  }

  return <NdcLabel ndc={ndc} needsAttention={needsAttention} />;
};
